import TweenLite from 'gsap';

const scrollToError = function($el){
    if(!$el) {
        $el = document;
    }

    // make sure that everything is rendered
    setTimeout(() => {
        const firstError = $el.getElementsByClassName('formfield--error')[0];

        if(firstError) {
            const rect = firstError.getBoundingClientRect();
            TweenLite.to('body, html', 1, {scrollTop: document.documentElement.scrollTop + rect.top - 40});
        }
    });
}

export default scrollToError;